import React from "react";
import Profile from "./WithProfile";
import Image from "./WithImage";
var ModalHeader = function (_a) {
    var image = _a.image, user = _a.user, size = _a.size, alt = _a.alt, alignLeft = _a.alignLeft, backgroundColor = _a.backgroundColor;
    return (React.createElement(React.Fragment, null,
        image && React.createElement(Image, { image: image, size: size, alt: alt, alignLeft: alignLeft, backgroundColor: backgroundColor }),
        user && React.createElement(Profile, { user: user, size: size })));
};
export default ModalHeader;
